<section class="reports-main-section">
  <div class="reports-list-wrapper">
    <!-- <div class="search-wrapper">
        <input type="text" class="cmn-header-search" placeholder="Search" />
      </div> -->
    <div class="reports-tab-wrapper">
      <mat-tab-group
        animationDuration="0ms"
        [(selectedIndex)]="selectedTabIndex"
        (selectedTabChange)="onTabChange($event)"
      >
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Profit & Loss</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Cash Flow Statement ##</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Trial Balance</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Balance Sheet</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Sales by Item ##</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Sales by Customer ##</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Account Type Summary ##</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Journal Report</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>General Ledger Report</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Customer Balance Summary</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Payment Received Report</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Payment Made Report</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Vendor Balance Summary</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Petty Cash Report</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Aging Report for Invoice</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Aging Report for Vendor Invoice</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Account Ledger Report</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>VAT Report</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Day Book Report</h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Bank Reconciliation Report </h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Expense Report </h2>
          </ng-template>
        </mat-tab>
        <mat-tab label="Profile">
          <ng-template mat-tab-label>
            <h2>Movement Trial Balance Report </h2>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div class="reports-main-content-wrapper">
    <div class="head-wrapper">
      <div class="head">
        <div *ngIf="![10, 18, 11, 13, 19, 20].includes(selectedTabIndex)" class="branch-wrapper">
          <h3>Date Range</h3>
          <div class="form-wrapper">
            <form [formGroup]="dateRangeForm">
              <mat-form-field>
                <mat-date-range-input [rangePicker]="picker">
                  <input
                    matStartDate
                    placeholder="Start date"
                    formControlName="startDate"
                    (dateInput)="
                      onDateChange($event, 'start', selectedTabIndex)
                    "
                  />
                  <input
                    matEndDate
                    placeholder="End date"
                    formControlName="endDate"
                    (dateInput)="onDateChange($event, 'end', selectedTabIndex)"
                  />
                </mat-date-range-input>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </form>
          </div>
        </div>

        <div *ngIf="selectedTabIndex === 18" class="branch-wrapper">
          <h3>Date</h3>
          <div class="form-wrapper">
            <form [formGroup]="singleDateForm">
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="singleDatepicker"
                  placeholder="Choose date"
                  formControlName="chooseDate"
                  (dateInput)="onDateChange($event, 'single', selectedTabIndex)"
                />
                <mat-datepicker-toggle matIconSuffix [for]="singleDatepicker">
                </mat-datepicker-toggle>
                <mat-datepicker #singleDatepicker></mat-datepicker>
              </mat-form-field>
            </form>
          </div>
        </div>

        <div *ngIf="selectedTabIndex === 14 || selectedTabIndex === 15">
          <form [formGroup]="dateRangeForm" class="form-flex">
            <!-- Customer Selection for Invoice Aging Report -->
            <mat-form-field *ngIf="selectedTabIndex === 14">
              <mat-select
                placeholder="Select Customer"
                [(value)]="selectedCustomerId"
                (selectionChange)="onCustomerChange($event.value)"
              >
                <mat-option
                  *ngFor="let customer of customerData"
                  [value]="customer.id"
                >
                  {{ customer?.firstName + " " + customer?.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Vendor Selection for Vendor Invoice Aging Report -->
            <mat-form-field *ngIf="selectedTabIndex === 15">
              <mat-select
                placeholder="Select Vendor"
                [(value)]="selectedVendorId"
                (selectionChange)="onVendorChange($event.value)"
              >
                <mat-option
                  *ngFor="let vendor of vendorData"
                  [value]="vendor.id"
                >
                  {{ vendor.vendorName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>

        <div *ngIf="selectedTabIndex === 16">
          <form
            *ngIf="accountsData"
            [formGroup]="accountForm"
            class="form-flex"
          >
            <!-- Account selection for fetching accounts report -->
            <mat-form-field *ngIf="selectedTabIndex === 16">
              <mat-select
                placeholder="Select an account"
                [(value)]="selectedAccountId"
                (selectionChange)="onAccountSelection($event.value)"
              >
                <mat-option
                  *ngFor="let account of accountsData"
                  [value]="account?.id"
                >
                  {{ account?.accountName }}
                  {{
                    account?.accountCode != ""
                      ? " - " + account?.accountCode
                      : ""
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>

      </div>
      <div>
        <button *ngIf="![10, 11, 13, 19, 20].includes(selectedTabIndex) && (canExportReports$ | async)" class="cmn-export-btn btn-align" (click)="toggleExport($event)">
          <img src="assets/images/icons/icon-export.svg" alt="Filter Icon" />
          <!-- <span>Export</span> -->
        </button>
        <div
          [ngClass]="{ show: isExportOpen }"
          class="common-dropdown export-position"
          #export
        >
          <button
            class="close-dropdown"
            (click)="toggleExport($event)"
          ></button>
          <h2>Export Table</h2>
          <br />
          <h3>File Type</h3>
          <!-- Format Selection -->
          <div class="format-selection">
            <label class="radiobtn-wrapper">
              <input
                type="radio"
                name="exportFormat"
                value="pdf"
                [(ngModel)]="exportFormat"
              />
              <span class="radiomark"></span>
              PDF
            </label>
            <label class="radiobtn-wrapper">
              <input
                type="radio"
                name="exportFormat"
                value="xls"
                [(ngModel)]="exportFormat"
              />
              <span class="radiomark"></span>
              XLS
            </label>
            <label class="radiobtn-wrapper">
              <input
                type="radio"
                name="exportFormat"
                value="csv"
                [(ngModel)]="exportFormat"
              />
              <span class="radiomark"></span>
              CSV
            </label>
          </div>

          <div class="btn-wrapper">
            <button
              class="cmn-apply-btn"
              type="submit"
              (click)="exportReports()"
            >
              Export
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loading" class="loading-message">Loading...</div>
    <div *ngIf="!loading">
      <div *ngIf="selectedTabIndex === 0">
        <app-profit-loss
          [profitLossData]="profitLossData"
          [startDate]="startDate"
          [endDate]="endDate"
          >></app-profit-loss
        >
      </div>
      <div *ngIf="selectedTabIndex === 1">
        <app-cash-flow-statement
          [cashFlowReport]="cashFlowReport"
          [startDate]="startDate"
          [endDate]="endDate"
        >
        </app-cash-flow-statement>
      </div>
      <div *ngIf="selectedTabIndex === 2">
        <app-trial-balance-statement
          [trialBalanceReport]="trialBalanceReport"
          [startDate]="startDate"
          [endDate]="endDate"
        >
        </app-trial-balance-statement>
      </div>
      <div *ngIf="selectedTabIndex === 3">
        <app-balance-sheet
          [balanceSheetReport]="balanceSheetReport"
          [startDate]="startDate"
          [endDate]="endDate"
        ></app-balance-sheet>
      </div>
      <div *ngIf="selectedTabIndex === 4">
        <app-sales-by-item
          [salesByItemReport]="salesByItemReport"
          [startDate]="startDate"
          [endDate]="endDate"
        ></app-sales-by-item>
      </div>
      <div *ngIf="selectedTabIndex === 7">
        <app-journal-report
          [journalReport]="journalReport"
          [startDate]="startDate"
          [endDate]="endDate"
        >
        </app-journal-report>
      </div>
      <div *ngIf="selectedTabIndex === 8">
        <app-general-ledger-report
          [generalLedgerReport]="generalLedgerReport"
          [startDate]="startDate"
          [endDate]="endDate"
        ></app-general-ledger-report>
      </div>
      <div *ngIf="selectedTabIndex === 9">
        <app-customer-balance-summary-report
          [customerBalanceSummaryReport]="customerBalanceSummaryReport"
          [startDate]="startDate"
          [endDate]="endDate"
        ></app-customer-balance-summary-report>
      </div>
      <div *ngIf="selectedTabIndex === 12">
        <app-vendor-balance-summary [vendorBalanceSummaryReport]="vendorBalanceSummaryReport" [startDate]="startDate"
          [endDate]="endDate"></app-vendor-balance-summary>
      </div>
      <div *ngIf="selectedTabIndex === 14">
        <app-aging-invoice
          [agingInvoiceReport]="agingInvoiceReport"
          [startDate]="startDate"
          [endDate]="endDate"
        ></app-aging-invoice>
      </div>
      <div *ngIf="selectedTabIndex === 15">
        <app-aging-vendor-invoice
          [agingVendorInvoice]="agingVendorInvoiceReport"
          [startDate]="startDate"
          [endDate]="endDate"
        >
        </app-aging-vendor-invoice>
      </div>
      <div *ngIf="selectedTabIndex === 16">
        <app-accounts-report
          [accountReport]="accountReport"
          [startDate]="startDate"
          [endDate]="endDate"
        >
        </app-accounts-report>
      </div>
      <div *ngIf="selectedTabIndex === 17">
        <app-vat-report
          [vatReportData]="vatReportData"
          [startDate]="startDate"
          [endDate]="endDate"
        >
        </app-vat-report>
      </div>
      <div *ngIf="selectedTabIndex === 18">
        <app-day-book-report
          [dayBookReportData]="dayBookReportData"
          [chooseDate]="chooseDate"
        >
        </app-day-book-report>
      </div>
      <div *ngIf="selectedTabIndex === 21">
        <app-movement-trial-balance-statement
        [movementTrialBalanceReport]="movementTrialBalanceReport"
        [startDate]="startDate"
        [endDate]="endDate"
        >
        </app-movement-trial-balance-statement>
      </div>
    </div>
  </div>
</section>
